import { useNotificationQuery } from "@faire/retailer/components/Header/HeaderNotifications/hooks/useNotificationQuery";
import { useNotificationRealTimeUpdate } from "./useNotificationRealTimeUpdate";

export const useNotifications = () => {
  useNotificationRealTimeUpdate();
  const { data } = useNotificationQuery();
  const notifications = data?.notifications;

  return {
    notifications,
    notificationCount: notifications?.length ?? 0,
  };
};
